import React from "react";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import "../style/contract_us.css";
import { useTranslation } from 'react-i18next';
import ContactUs from "../components/contact_us";

const Contract_us = () => {
  const { t } = useTranslation();
  const handleRedirectWP = () => {
    window.open("https://api.whatsapp.com/send?phone=573025779018")
  };

  return (
    <>
      <Header></Header>
      <div className="contact-us-container">
        <div className="contact-us-total">
          <div className="contract-us-set">
            <p>{t('CONTACT_US_TITLE')}</p>
            <button
              className="wsp-contact-button"
              onClick={handleRedirectWP}
            >
              <img src="/img/wsp_black_icon.svg" alt="Whatsapp Logo para chatear con nosotros" />
              {t('AUT_BUTTON')}
            </button>
          </div>
        </div>
        <ContactUs/>
      </div>
      <Footer></Footer>
    </>
  );
};

export default Contract_us;
